import React from 'react';
import { FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-pearl/70 py-14 border-t border-gold/10" data-id="element-42">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 mb-10" data-id="element-44">
          {/* Contact */}
          <div className="lg:col-span-4" data-id="element-45">
            <h4 className="font-inter font-semibold text-white mb-4 uppercase text-[13px] tracking-[0.15em]" data-id="element-46">
              Contact
            </h4>
            <div className="space-y-1.5 font-inter text-[13px] leading-relaxed" data-id="element-47">
              <p className="font-montserrat font-bold text-white text-[13px]" data-id="element-48">
                PASCU RADU VASILE ÎNTREPRINDERE INDIVIDUALĂ
              </p>
              <p data-id="element-49">CUI: 38416337</p>
              <p data-id="element-50">Nr. înmatriculare: F32/667/2017</p>
              <p data-id="element-51">Data înființării: 27/10/2017</p>
              <p data-id="element-52">Sibiu, România</p>
              <p data-id="element-53">
                Telefon:{' '}
                <a href="tel:+40770276406" className="hover:text-gold transition-colors" data-id="element-54">
                  +40 770 276 406
                </a>
              </p>
              <p data-id="element-55">
                Email:{' '}
                <a href="mailto:nutrisib.club@gmail.com" className="hover:text-gold transition-colors" data-id="element-56">
                  nutrisib.club@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Legal */}
          <div className="lg:col-span-2" data-id="element-57">
            <h4 className="font-inter font-semibold text-white mb-4 uppercase text-[13px] tracking-[0.15em]" data-id="element-58">
              Legal
            </h4>
            <ul className="space-y-2 font-inter text-[13px]" data-id="element-59">
              <li data-id="element-60">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-61">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-63">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-65">
                  Politica de Cookies
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-67">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* Navigare */}
          <div className="lg:col-span-2" data-id="element-68">
            <h4 className="font-inter font-semibold text-white mb-4 uppercase text-[13px] tracking-[0.15em]" data-id="element-69">
              Navigare
            </h4>
            <ul className="space-y-2 font-inter text-[13px]" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-72">
                  Despre Metodă
                </a>
              </li>
              <li data-id="element-73">
                <a href="https://nutrisib.club/celos" className="hover:text-gold transition-colors" data-id="element-74">
                  NUTRISIB Club
                </a>
              </li>
              <li data-id="element-75">
                <a href="https://nutrisib.club/formular" className="hover:text-gold transition-colors" data-id="element-76">
                  Evaluare Avansată
                </a>
              </li>
              <li data-id="element-77">
                <a href="https://nutrisib.club/blog" className="hover:text-gold transition-colors" data-id="element-78">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="lg:col-span-2" data-id="element-79">
            <h4 className="font-inter font-semibold text-white mb-4 uppercase text-[13px] tracking-[0.15em]" data-id="element-80">
              Social Media
            </h4>
            <ul className="space-y-2 font-inter text-[13px]" data-id="element-81">
              <li data-id="element-82">
                <a href="https://www.facebook.com/rvpascu" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-83">
                  <FacebookIcon className="w-4 h-4" data-id="element-84" /> Facebook
                </a>
              </li>
              <li data-id="element-85">
                <a href="https://www.instagram.com/rvpascu/" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-86">
                  <InstagramIcon className="w-4 h-4" data-id="element-87" /> Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* ANPC Badges */}
          <div className="lg:col-span-2 flex flex-col gap-3 lg:items-end" data-id="element-88">
            <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer" className="block" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/1wobUUdxDFuEZaEtQyBWzd/ANPC.webp" alt="ANPC — Soluționarea Alternativă a Litigiilor" className="h-12 rounded bg-white p-1" data-id="element-90" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="block" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/4ega2Q6DTM3UWDKtTHSfhE/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="h-12 rounded bg-white p-1" data-id="element-92" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 border-t border-white/10 text-center" data-id="element-93">
          <p className="font-inter text-[12px] text-pearl/40" data-id="element-94">
            &copy; Copyright {new Date().getFullYear()}. NUTRISIB — dr.ing. Radu
            Pascu. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}